import { OrgAuthCallbackPage } from "@solomon-apps/shared";
import * as React from "react";

import { CLIENT_OAUTH_CONFIG } from "@/constants/oauthConfig";

export function CallbackPage(): React.ReactElement {
    return (
        <OrgAuthCallbackPage
            config={CLIENT_OAUTH_CONFIG}
            appLabel="Company Recipient Console"
        />
    );
}
